import { useNavigate } from 'react-router-dom';

import type { Artist } from '@maestra/core/interfaces/maestra';
import { useCaminhoDoPro as useCaminhoDoProDoNucleo } from '@maestra/core/telas/dinheiro/caminhoDoPro';

// O CAMINHO PARA O PRO mora no núcleo desde 31/10/2026, para o app nativo seguir a mesma regra
// (docs/PLANO-APP-NATIVO.md). Aqui a web só entrega o `navigate`.
// Valor e tipo em duas linhas: num `export { valor, type Tipo } from`, o Babel do CRA descarta a
// linha inteira no dev server (o tsc não acusa).
export { CAMINHO_DO_PRO, situacaoDoPro } from '@maestra/core/telas/dinheiro/caminhoDoPro';
export type { CaminhoDoPro, SituacaoDoPro, SituacaoEspecial } from '@maestra/core/telas/dinheiro/caminhoDoPro';

/** O caminho para o PRO deste perfil, para quem olha agora. */
export const useCaminhoDoPro = (artist: Artist | null | undefined) => {
  const navigate = useNavigate();
  return useCaminhoDoProDoNucleo(artist, navigate);
};
